import { Flexbox } from "st-app";
import { GroupAction } from "./GroupAction";
import { Group } from "./Group";

import styles from '../sis-role-dashboard.module.css'
import { UserSuggestions } from "./UserSuggestions";
import { UserRecentHistory } from "./UserRecentHistory";
import { For, createMemo } from "solid-js";
import { requireRoleDashboardContext } from "../RoleDashboardContext";
import { StaffRole } from "../../../api";

export function NurseDashboard() {
    const ctx = requireRoleDashboardContext();

    const tasks = ctx.sortedActions([
        'HealthInfo.AddIncident',
        'HealthInfo.HealthCondition',
        'HealthInfo.Immunizations',
        'HealthInfo.Medications',
        'K12.LocateStudent',
    ]);

    const shortcuts = createMemo(() => {
        const addShortcuts = ctx.configuration()
            ?.additionalShortcuts
            .filter(desc => desc.role === StaffRole.Nurse)
            .map(desc => desc.ID!);

        return ctx.sortedActions([
            'K12.PersonSearch',
            'HealthInfo.Health',
            'HealthInfo.HealthScreen',
            'HealthInfo.HealthLogOther',
            'HealthInfo.MedServiceMonitor',
        ].concat(addShortcuts ?? []));
    });

    return <Flexbox dir="horizontal" auto class={styles['dashboard-content']} >
        <Flexbox dir="vertical" auto>
            <Group title="Tasks" icon="fas fa-graduation-cap" color="--header-green">
                <For each={tasks}>{id => <GroupAction id={id} />}</For>
            </Group>

            <Group title="Shortcuts" icon="fas fa-info-circle" color="--header-blue">
                <For each={shortcuts()}>{id => <GroupAction id={id} allowDetach />}</For>
            </Group>

            <UserSuggestions />
            <Flexbox.Item auto />
        </Flexbox>
        <UserRecentHistory />
    </Flexbox>
}

